import { render, staticRenderFns } from "./DraftListEditA1.vue?vue&type=template&id=ff3de57e"
import script from "./DraftListEditA1.vue?vue&type=script&lang=js"
export * from "./DraftListEditA1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports